import { AppRegistry } from "react-native";
import App from "./App";
import "./assets/css/index.css";

AppRegistry.registerComponent("App", () => App);
AppRegistry.runApplication("App", { rootTag: document.getElementById("root") });
